
import { Component, Prop, Provide, Vue, Watch } from "vue-property-decorator";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

@Component({
  components: {},
  filters: {},
})
export default class Test extends Vue {
  /// props
  @Prop({ default: "" }) private basePath!: string;

  @Prop() private locations!: Array<any>;

  /// data
  private data: Object = {};

  /// provide data
  @Provide() provideData: Object = {};

  // computed
  private get infos(): Array<any> {
    return Array<any>();
  }

  private chart: any = undefined;

  private formatAddress(gps: any): string {
    if (gps && gps !== undefined) {
      var addressList =
        (gps && [gps.city || "", gps.province || "", gps.country || ""]) || [];
      var country = (gps && gps.country) || "";
      if (country === "中国" || country === "中國") {
        addressList = addressList.reverse();
      }
      return addressList.join(" ");
    }
    return "";
  }

  /// lifecycle
  created() {}

  mounted() {
    let targetSVG =
      "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

    let planeSVG = "m2,106h28l24,30h72l-44,-133h35l80,132h98c21,0 21,34 0,34l-98,0 -80,134h-35l43,-133h-71l-24,30h-28l15,-47"
    
    let colorSet = {
      Farmer: "#57BCF9",
    };

    // let colorSet = {
    //   Farmer: "#E0301E",
    //   Supplier: "#D04A02",
    //   Warehouse: '#EB8C00',
    //   Store: '#FFB600'
    // }

    let alphaColorSet = {
      Farmer: "rgba(87, 188, 249, 0.32)",
    };

    // let planes: Array<any> = [
    //   {
    //     svgPath: planeSVG,
    //     positionOnLine: 0,
    //     color: '#D3D3D3',
    //     alpha: 0.4,
    //     animateAlongLine: true,
    //     lineId: 'line2',
    //     flipDirection: false,
    //     loop: true,
    //     scale: 0.03,
    //     positionScale: 1.1
    //   },
    //   {
    //     svgPath: planeSVG,
    //     positionOnLine: 0,
    //     color: '#3A45B1',
    //     animateAlongLine: true,
    //     lineId: 'line1',
    //     flipDirection: false,
    //     loop: true,
    //     scale: 0.03,
    //     positionScale: 1.3
    //   }
    // ]
    let locations = this.locations.map((location) => {
      let type = location.type;
      let title = location.sendingorg || location.receivingorg || location.city;
      let address = this.formatAddress(location);
      let color = colorSet["Farmer"];
      let alphaColor = alphaColorSet["Farmer"];
      return {
        svgPath: targetSVG,
        title: title,
        "background-color": "#ffffff",
        latitude: parseFloat(location.lat),
        longitude: parseFloat(location.lon),
        scale: 1,
        color: color,
        alphaColor: alphaColor,
      };
    });

    // Create map instance
    let chart = am4core.create(
      this.$refs.chartdiv as HTMLElement,
      am4maps.MapChart
    );
    let interfaceColors = new am4core.InterfaceColorSet();

    // Set map definition
    chart.geodata = am4geodata_worldLow;

    // Set projection
    chart.projection = new am4maps.projections.Mercator();

    // Add zoom control
    chart.zoomControl = new am4maps.ZoomControl();

    // Set initial zoom
    chart.homeZoomLevel = 5;
    let currentLocation = this.locations[0];
    let lastLocation =
      !currentLocation.lat && !currentLocation.lon
        ? { lat: 31.41, lon: 121.48 }
        : { lat: currentLocation.lat, lon: currentLocation.lon };
    // this.locations[0]
    chart.homeGeoPoint = {
      latitude: lastLocation.lat,
      longitude: lastLocation.lon,
    };

    // Create map polygon series
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.exclude = ["AQ"];
    polygonSeries.useGeodata = true;
    // polygonSeries.fill = new am4core.Color(
    //     ({ r: 242 , g: 245 , b: 248 } as am4core.iRGB)
    // )
    // chart.colors.getIndex(0);
    polygonSeries.mapPolygons.template.nonScalingStroke = true;
    polygonSeries.mapPolygons.template.fill = new am4core.Color({
      r: 230,
      g: 239,
      b: 245,
    } as am4core.iRGB);
    // chart.colors.getIndex(0)

    let lineSeries = chart.series.push(new am4maps.MapLineSeries());
    lineSeries.mapLines.template.shortestDistance = true;
    lineSeries.mapLines.template.line.stroke = am4core.color("#00BFFF");
    // lineSeries.mapLines.template.line.strokeOpacity = 0.5;
    lineSeries.mapLines.template.line.strokeWidth = 0.1;
    lineSeries.mapLines.template.line.strokeDasharray = "3,1";

    var line = lineSeries.mapLines.create();
    // lineSeries.data = locations
    line.multiGeoLine = [
        locations
    ];

    // Add images
    let imageSeries = chart.series.push(new am4maps.MapImageSeries());
    let imageTemplate = imageSeries.mapImages.template;
    imageTemplate.tooltipText = "{title}";
    imageTemplate.nonScaling = true;

    let circle = imageSeries.mapImages.template.createChild(am4core.Circle);
    circle.radius = 8;
    circle.propertyFields.fill = "color";

    let circle2 = imageSeries.mapImages.template.createChild(am4core.Circle);
    circle2.radius = 16;
    circle2.propertyFields.fill = "alphaColor";

    imageTemplate.propertyFields.latitude = "latitude";
    imageTemplate.propertyFields.longitude = "longitude";

    // let alphaColorSet = {
    //   Farmer: 'rgba(224,48,30,0.3)',
    //   Supplier: 'rgba(208,74,2,0.3)',
    //   Warehouse: 'rgba(235,140,0,0.3)',
    //   Store: 'rgba(255,182,0,0.3)'
    // }

    // if (this.mockVid) {
    //     this.locations = this.locations.map(item => {
    //       if (item.timestamp === 1607954775661) {
    //         item.lat = "14.8701799"
    //         item.lon = "120.9841384"
    //         item.address = "Manila, Philippines"
    //         item.country = "Philippines"
    //         item.city = "Manila"
    //       }
    //       return item
    //     })
    // }
    // console.log("mockvid", this.mockVid)
    // console.log("locations", this.locations)

    // const mocklocations: Array<any> = [{
    //         lat: 31.41,
    //         lon: 121.48,
    //         sendingorg: "中国 上海 上海",
    //         city: '上海',
    //         country: '中国',
    //         province: '',

    //     }]

    imageSeries.data = locations
    // imageSeries.data = citys.concat(planes)

    let cities = chart.series.push(new am4maps.MapImageSeries());
    cities.mapImages.template.nonScaling = true;

    function addCity(coords: any, title: string) {
      let city = cities.mapImages.create();
      city.latitude = coords.latitude;
      city.longitude = coords.longitude;
      city.tooltipText = title;
      city.alwaysShowTooltip = true;
      city.fill = am4core.color("#57BCF9", 0.1);
      return city;
    }

    addCity(
      { latitude: currentLocation.lat, longitude: currentLocation.lon },
      !currentLocation.country && !currentLocation.city
        ? currentLocation.address.length > 10
          ? currentLocation.address.substr(0, 10) + "..."
          : currentLocation.address
        : currentLocation.city
    );

    // let plane1 = cities.mapImages.create();
    //   // city.latitude = coords.latitude;
    //   // city.longitude = coords.longitude;

    //   plane1.tooltipText = title;
    //   plane1.alwaysShowTooltip = true;
    //   plane1.fill = am4core.color("#57BCF9", 0.1);
    //   plane1.svgPath = planeSVG;

    //   let planes = [
		// 		{
		// 			svgPath: planeSVG,
		// 			positionOnLine: 0,
		// 			color: '#D3D3D3',
		// 			alpha: 0.4,
		// 			animateAlongLine: true,
		// 			lineId: 'line2',
		// 			flipDirection: false,
		// 			loop: true,
		// 			scale: 0.03,
		// 			positionScale: 1.1
		// 		},
		// 		{
		// 			svgPath: planeSVG,
		// 			positionOnLine: 0,
		// 			color: '#3A45B1',
		// 			animateAlongLine: true,
		// 			lineId: 'line1',
		// 			flipDirection: false,
		// 			loop: true,
		// 			scale: 0.03,
		// 			positionScale: 1.3
		// 		}
		// 	]

    // let lineSeries = chart.series.push(new am4maps.MapLineSeries());
    // // lineSeries.data = locations
    // lineSeries.data = [{
    //     "multiGeoLine": [
    //       [
    //         { "latitude": 48.856614, "longitude": 2.352222 },
    //         { "latitude": 40.712775, "longitude": -74.005973 },
    //         { "latitude": 49.282729, "longitude": -123.120738 }
    //       ]
    //     ]
    //   }];
    // [{
    //   "multiGeoLine": locations
    // }]

    // let lineSeries = chart.series.push(am5map.MapLineSeries.new(root, {}));
    // lineSeries.mapLines.template.setAll({
    //   stroke: root.interfaceColors.get("alternativeBackground"),
    //   strokeOpacity: 0.3
    // });

    this.chart = chart;

    var bullet = line.lineObjects.create();
    bullet.nonScaling = true;
    bullet.position = 0;
    bullet.width = 48;
    bullet.height = 48;

    var plane = bullet.createChild(am4core.Sprite);
    plane.scale = 0.08;
    plane.horizontalCenter = "middle";
    plane.verticalCenter = "middle";
    plane.path = "m2,106h28l24,30h72l-44,-133h35l80,132h98c21,0 21,34 0,34l-98,0 -80,134h-35l43,-133h-71l-24,30h-28l15,-47";
    plane.fill = am4core.color("#3e96e0");
    plane.strokeOpacity = 0;

    function goPlane() {
      var from = bullet.position, to;
      if (from == 0) {
        to = 1;
        plane.rotation = 0;
      }
      else {
        to = 1;
        plane.rotation = 0;
        bullet.position = 0;
      //   plane.rotation = 180;
      }
      
      var animation = bullet.animate({
        from: from,
        to: to,
        property: "position"
      }, 2000, am4core.ease.sinInOut);

      animation.events.on("animationended", goPlane)
    }
    goPlane();
    // setInterval(()=> {
    //   bullet.position = 0;
    //   goPlane();
    //   // console.log("animation_plane")
    // }, 2000)
    // goPlane();
  }
}
